/* Lavae Custom Scripts */
/* All Lavae-specific JS goes here. Uses ES2020+ and @theme/* imports. */

document.addEventListener('DOMContentLoaded', () => {
  // Savings callout: inject "Risparmi X EUR" after price when compare-at exists
  const priceBlock = document.querySelector('.product-information .price');
  if (!priceBlock) return;

  const callout = document.createElement('p');
  callout.className = 'lavae-savings-callout';

  function updateSavings() {
    const compareEl = priceBlock.querySelector('.compare-at-price');
    const priceEl = priceBlock.querySelector('.sale-price')
      || priceBlock.querySelector('.regular-price');
    if (!compareEl || !priceEl) {
      callout.textContent = '';
      return;
    }

    const parse = (el) => {
      const text = el.textContent.replace(/[^\d,.]/g, '').replace(',', '.');
      return parseFloat(text);
    };

    const compareAt = parse(compareEl);
    const price = parse(priceEl);

    if (compareAt > price) {
      const savings = compareAt - price;
      const formatted = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }).format(savings);
      callout.textContent = `Risparmi ${formatted}`;
      if (!callout.parentNode) {
        priceBlock.insertAdjacentElement('afterend', callout);
      }
    } else {
      callout.textContent = '';
    }
  }

  updateSavings();

  // Update on variant change
  document.addEventListener('variant:change', updateSavings);
});

/**
 * 1-click add-to-cart for cart cross-sell ("Completa il set").
 * Called via onclick from the cross-sell button in custom.cart-cross-sell.liquid.
 * Uses bundled section rendering so cart-items-component morphs with fresh HTML.
 *
 * @param {HTMLButtonElement} button - The CTA button with data-variant-id
 */
/**
 * Newsletter popup: 60s timer / 50% scroll trigger, localStorage suppression,
 * cookie consent sequencing, and subscription success detection.
 */
(function () {
  var POPUP_DELAY_MS = 60000;
  var SCROLL_THRESHOLD = 0.5;
  var DISMISS_DAYS = 30;
  var LS_SUBSCRIBED = 'lavae_nl_subscribed';
  var LS_DISMISSED = 'lavae_nl_dismissed';

  console.log('[Lavae Popup] IIFE started, readyState:', document.readyState);

  function initPopup() {
    console.log('[Lavae Popup] initPopup() called');
    var dialog = document.getElementById('lavae-popup-dialog');
    console.log('[Lavae Popup] dialog element:', dialog);
    if (!dialog) {
      console.warn('[Lavae Popup] Dialog element NOT FOUND - section may not be rendered');
      return;
    }

    var shown = false;

    // Check suppression
    try {
      if (localStorage.getItem(LS_SUBSCRIBED) === '1') {
        console.log('[Lavae Popup] Suppressed: user already subscribed');
        return;
      }
      var dismissedAt = localStorage.getItem(LS_DISMISSED);
      if (dismissedAt && (Date.now() - parseInt(dismissedAt, 10)) < DISMISS_DAYS * 86400000) {
        console.log('[Lavae Popup] Suppressed: dismissed within', DISMISS_DAYS, 'days');
        return;
      }
    } catch (e) {
      console.log('[Lavae Popup] localStorage error (incognito?):', e.message);
      // Incognito or storage disabled -- continue without suppression
    }
    console.log('[Lavae Popup] Not suppressed, setting up triggers');

    // Subscription success detection (page reloaded after form POST)
    var successEl = dialog.querySelector('.lavae-popup__success');
    if (successEl) {
      try { localStorage.setItem(LS_SUBSCRIBED, '1'); } catch (e) {}
      dialog.showModal();
      setTimeout(function () { dialog.close(); }, 5000);
      return;
    }

    /**
     * Check if consent banner is currently visible in the DOM.
     *
     * Strategy: Check for iubenda banner visibility first (our CMP), then fall back
     * to Shopify's native banner detection.
     *
     * NOTE: We do NOT use Shopify's shouldShowBanner() because it returns true based
     * on REGION, not actual consent state. With third-party CMPs like iubenda, this
     * API always returns true for EU visitors even after consent is collected.
     *
     * @returns {boolean} true if a consent banner is currently visible
     */
    function isConsentBannerVisible() {
      // Check for iubenda banner (our CMP)
      // iubenda injects #iubenda-cs-banner and shows/hides it via CSS
      var iubendaBanner = document.getElementById('iubenda-cs-banner');
      if (iubendaBanner) {
        // Check if banner is actually visible (not hidden via CSS)
        var style = window.getComputedStyle(iubendaBanner);
        var isVisible = style.display !== 'none' &&
                        style.visibility !== 'hidden' &&
                        parseFloat(style.opacity) > 0;
        console.log('[Lavae Popup] iubenda banner found, visible:', isVisible);
        return isVisible;
      }

      // Check for Shopify's native consent banner (for stores not using iubenda)
      // Shopify's banner uses the shopify-pc__banner class
      var shopifyBanner = document.querySelector('.shopify-pc__banner');
      if (shopifyBanner) {
        var style = window.getComputedStyle(shopifyBanner);
        var isVisible = style.display !== 'none' &&
                        style.visibility !== 'hidden' &&
                        parseFloat(style.opacity) > 0;
        console.log('[Lavae Popup] Shopify banner found, visible:', isVisible);
        return isVisible;
      }

      // No consent banner detected - safe to show popup
      console.log('[Lavae Popup] No consent banner detected');
      return false;
    }

    function showPopup() {
      console.log('[Lavae Popup] showPopup() called, shown:', shown);
      if (shown) {
        console.log('[Lavae Popup] Already shown, skipping');
        return;
      }
      // Defer when consent banner is visible
      if (isConsentBannerVisible()) {
        console.log('[Lavae Popup] Deferred: consent banner is visible');
        return;
      }
      shown = true;
      console.log('[Lavae Popup] Calling dialog.showModal()');
      dialog.showModal();
    }

    // Time trigger
    console.log('[Lavae Popup] Setting up time trigger:', POPUP_DELAY_MS, 'ms');
    setTimeout(showPopup, POPUP_DELAY_MS);

    // Scroll trigger
    function onScroll() {
      var scrollPct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (scrollPct >= SCROLL_THRESHOLD) {
        window.removeEventListener('scroll', onScroll);
        showPopup();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // Consent sequencing (Phase 7 compatibility)
    document.addEventListener('visitorConsentCollected', function () {
      setTimeout(showPopup, 2000);
    });

    // Dismiss handling
    dialog.addEventListener('close', function () {
      try { localStorage.setItem(LS_DISMISSED, String(Date.now())); } catch (e) {}
    });

    var dismissBtn = dialog.querySelector('.lavae-popup__dismiss');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () { dialog.close(); });
    }

    var closeBtn = dialog.querySelector('.lavae-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { dialog.close(); });
    }
  }

  // Ensure DOM is ready before initializing popup
  if (document.readyState === 'loading') {
    console.log('[Lavae Popup] DOM loading, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', initPopup);
  } else {
    console.log('[Lavae Popup] DOM already ready, calling initPopup immediately');
    initPopup();
  }
})();

/**
 * Replace cart cross-sell: removes individual piece, adds coordinated set.
 * Called via onclick from the cross-sell button in custom.cart-cross-sell.liquid.
 * Uses sequential AJAX calls: cart/change (remove) then cart/add (add set).
 *
 * @param {HTMLButtonElement} button - The CTA button with data-variant-id and data-piece-line-key
 */
async function lavaeReplaceCrossSell(button) {
  var setVariantId = button.dataset.variantId;
  var pieceLineKey = button.dataset.pieceLineKey;

  if (!setVariantId || !pieceLineKey) {
    console.error('lavaeReplaceCrossSell: Missing variant ID or piece line key');
    return;
  }

  var originalText = button.textContent;
  button.disabled = true;
  button.textContent = '...';

  var removeSucceeded = false;

  try {
    // Step 1: Remove the individual piece
    var removeResponse = await fetch(Theme.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: pieceLineKey,
        quantity: 0
      })
    });

    if (!removeResponse.ok) {
      throw new Error('Failed to remove piece: ' + removeResponse.status);
    }

    removeSucceeded = true;

    // Step 2: Add the set with section rendering
    var cartComponents = document.querySelectorAll('cart-items-component');
    var sectionIds = [];
    cartComponents.forEach(function (c) {
      if (c.dataset.sectionId) sectionIds.push(c.dataset.sectionId);
    });

    var addResponse = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(setVariantId), quantity: 1 }],
        sections: sectionIds.join(',')
      })
    });

    if (!addResponse.ok) {
      throw new Error('Failed to add set: ' + addResponse.status);
    }

    var data = await addResponse.json();

    // Dispatch cart:update for theme components to refresh
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          data: { sections: data.sections, source: 'lavae-cross-sell-replace' }
        }
      })
    );

  } catch (error) {
    console.error('Cross-sell replace failed:', error);

    // If remove succeeded but add failed, cart is in partial state
    // Refresh page to show correct cart state to user
    if (removeSucceeded) {
      console.warn('Partial failure: piece removed but set not added. Refreshing page.');
      window.location.reload();
      return;
    }

    // If remove failed, restore button state
    button.disabled = false;
    button.textContent = originalText;
  }
}

/**
 * @deprecated Use lavaeReplaceCrossSell instead. This function adds the set
 * without removing the individual piece first, resulting in both items in cart.
 * Kept for backwards compatibility.
 *
 * @param {HTMLButtonElement} button - The CTA button with data-variant-id
 */
async function lavaeAddCrossSell(button) {
  var variantId = button.dataset.variantId;
  if (!variantId) return;

  var originalText = button.textContent;
  button.disabled = true;
  button.textContent = '...';

  try {
    // Collect section IDs from all cart-items-component elements on page
    var cartComponents = document.querySelectorAll('cart-items-component');
    var sectionIds = [];
    cartComponents.forEach(function (c) {
      if (c.dataset.sectionId) sectionIds.push(c.dataset.sectionId);
    });

    var response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
      }),
    });

    if (!response.ok) {
      throw new Error('Cart add failed: ' + response.status);
    }

    var data = await response.json();

    // Dispatch cart:update so all theme components (cart icon, drawer, etc.) refresh
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          data: { sections: data.sections, source: 'lavae-cross-sell' },
        },
      })
    );
  } catch (error) {
    console.error('Cross-sell add failed:', error);
    button.disabled = false;
    button.textContent = originalText;
  }
}

/**
 * Add-to-cart for "Acquista separatamente" piece cards on coordinato PDPs.
 * Called via onclick from custom.buy-separately-card.liquid.
 * Uses Cart API with bundled section rendering + cart:update event dispatch.
 *
 * @param {HTMLButtonElement} button - The CTA button with data-variant-id
 */
async function lavaeAddToCartFromCard(button) {
  var variantId = button.dataset.variantId;
  if (!variantId) return;

  var originalText = button.textContent;
  button.disabled = true;
  button.textContent = '...';

  try {
    // Collect section IDs from cart-items-component for bundled rendering
    var cartComponents = document.querySelectorAll('cart-items-component');
    var sectionIds = [];
    for (var c of cartComponents) {
      if (c.dataset.sectionId) sectionIds.push(c.dataset.sectionId);
    }

    var response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
      }),
    });

    if (!response.ok) {
      throw new Error('Buy separately add failed: ' + response.status);
    }

    var data = await response.json();

    // Dispatch cart:update -- triggers:
    // 1. CartDrawerComponent opens drawer (auto-open attribute)
    // 2. CartItemsComponent morphs cart HTML (free shipping bar, cross-sell refresh)
    // 3. CartIcon badge updates via section morph (no itemCount needed)
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          data: { sections: data.sections, source: 'lavae-buy-separately' },
        },
      })
    );

    // Reset button after success (allow repeated adds, e.g. buying as gift)
    // 800ms matches Horizon's AddToCartComponent.animateAddToCart timing
    setTimeout(function () {
      button.disabled = false;
      button.textContent = originalText;
    }, 800);

  } catch (error) {
    console.error('Buy separately add failed:', error);
    button.disabled = false;
    button.textContent = originalText;
  }
}

/* === Shipping Urgency (Phase 22) === */

/**
 * Shipping urgency: shows "Ordina entro le 13:00 per spedizione oggi"
 * on weekdays before 13:00 Europe/Rome time.
 *
 * Runs on page load and after variant changes (morph replaces DOM).
 * The urgency row is rendered with `hidden` attribute in Liquid.
 * This function only removes `hidden` when conditions are met.
 *
 * @see snippets/custom.trust-signals.liquid
 */
function lavaeInitShippingUrgency() {
  const el = document.querySelector('.lavae-trust__row--urgency');
  if (!el) return;

  const CUTOFF_HOUR = 13;
  const now = new Date();
  const romeTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Rome' }));
  const dayOfWeek = romeTime.getDay(); // 0=Sun, 1=Mon, ..., 5=Fri, 6=Sat
  const hour = romeTime.getHours();

  const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
  const isBeforeCutoff = hour < CUTOFF_HOUR;

  if (isWeekday && isBeforeCutoff) {
    el.removeAttribute('hidden');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lavaeInitShippingUrgency);
} else {
  lavaeInitShippingUrgency();
}

document.addEventListener('variant:update', lavaeInitShippingUrgency);
